module.exports = __webpack_public_path__ + "img/nouvelle_recette.a483bb31.png";